import { HTMLInputTypeAttribute } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { StatusBadge } from "./style";

export interface FormDataSource {
  id: string;
  label: string;
  type: HTMLInputTypeAttribute;
  placeholder: string;
  readOnly?: boolean;
}
export const ordersColumns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 50 },
  {
    field: "company",
    headerName: "Company",
    width: 200,
    renderCell: (params) => {
      return (
        <div>
          <p>{params.row.company?.name}</p>
        </div>
      );
    },
  },
  {
    field: "payment_status",
    headerName: "Payment",
    width: 100,
    renderCell: (params) => {
      const status = params.row.payment_status ?? "unpaid";
      const display = status === "succeeded" ? "paid" : status;
      return <StatusBadge status={status === "succeeded" ? "succeeded" : status}>{display}</StatusBadge>;
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
    renderCell: (params) => {
      const status = params.row.status || "pending";
      return <StatusBadge status={status}>{status}</StatusBadge>;
    },
  },
  {
    field: "user",
    headerName: "Customer",
    width: 150,
    renderCell: (params) => {
      return (
        <div>
          <p>{params.row.user?.username}</p>
        </div>
      );
    },
  },
  {
    field: "event",
    headerName: "Event",
    width: 350,
    renderCell: (params) => {
      return <span>{`${params.row.event?.full_name}`}</span>;
    },
  },
  {
    field: "net_price",
    headerName: "Net Price",
    width: 150,
    renderCell: (params) => {
      return <span>{`${params.row.total_price} ${params.row.event?.currency?.toUpperCase()}`}</span>;
      // return <span>{`${params.row.total_price} GBP`}</span>;
    },
  },
  {
    field: "total_price",
    headerName: "Total Price",
    width: 150,
    renderCell: (params) => {
      return <span>{`${params.row.total_price} ${params.row.event?.currency?.toUpperCase()}`}</span>;
      // return <span>{`${ (params.row.total_price * (1.0 + params.row.event.tax / 100)).toFixed(2) } GBP`}</span>;
    },
  },
  
  
  {
    field: "updated_at",
    headerName: "Date",
    width: 150,
    renderCell: (params) => {
      return <span>{`${params.row.updated_at}`}</span>;
    },
  },
];

export const productsColumns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 50 },
  {
    field: "name",
    headerName: "Title",
    width: 250,
    // renderCell: (params: GridValueGetterParams) => {
    //   return (
    //     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    //       <img
    //         style={{
    //           width: "40px",
    //           height: "40px",
    //           borderRadius: "50%",
    //           objectFit: "cover",
    //         }}
    //         src={params.row.img}
    //         alt={params.row.title}
    //       />
    //       <p>{params.row.title}</p>
    //     </div>
    //   );
    // },
  },

  {
    field: "description",
    headerName: "Description",
    width: 350,
  },
  {
    field: "product_code",
    headerName: "Product Code",
    width: 200,
    renderCell: (params) => {
      return <span>{`${params.row.product?.code || ''}`}</span>;
    },
  },
  {
    field: "category",
    headerName: "Category",
    width: 200,
    renderCell: (params) => {
      return <span>{`${params.row.category.name}`}</span>;
    },
  },
  {
    field: "price",
    headerName: "Price",
    width: 150,
    renderCell: (params) => {
      // return <span>{`£ ${params.row.price}`}</span>;
      return <span>{`${params.row.price} ${params.row.currency}`}</span>;
    },
  },
  {
    field: "quantity",
    headerName: "Quantity",
    width: 150,
    // renderCell: (params: GridValueGetterParams) => {
    //   return <span>{`${params.row.stock} pieces`}</span>;
    // },
  },
  // {
  //   field: "updated_at",
  //   headerName: "Date",
  //   width: 150,
  //   // renderCell: (params: GridValueGetterParams) => {
  //   //   return <span>{`${params.row.stock} pieces`}</span>;
  //   // },
  // },
  
];

export const formProductInput: FormDataSource[] = [
  {
    id: "name",
    label: "Title",
    type: "text",
    placeholder: "Apple Macbook Pro",
  },
  {
    id: "description",
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: "category_id",
    label: "Category",
    type: "select",
    placeholder: "Category",
  },
  {
    id: "price",
    label: "Price(£)",
    type: "text",
    placeholder: "100",
  },
  {
    id: "stock",
    label: "Stock",
    type: "text",
    placeholder: "in stock",
  },
];

